import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/style.css'

import global_ from './components/common/Global'//引用全局变量
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面

//导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'

//导入富文本css
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

import Myeditor from "./components/common/MyEditor.vue"   //引入组件
Vue.component("myeditor",Myeditor);

Vue.config.productionTip = false
import axios from 'axios'
// axios.defaults.baseURL = 'http://localhost:9000/'
axios.defaults.baseURL =  'https://yueqiapi.vom-string.com/'
axios.interceptors.request.use(config => {
  const site = window.sessionStorage.getItem('site') || 'miniapp'
  // site 走 query/body，避免自定义头触发 CORS 预检被线上拦截
  if (config.method === 'get') {
    config.params = { ...(config.params || {}), site }
  } else if (config.data != null && typeof config.data === 'object' && !(config.data instanceof FormData)) {
    const payload = config.data
    config.data = { ...payload, site }
  } else if (!config.data || config.data === '') {
    config.data = { site }
  }
  return config
})


import VueRouter from 'vue-router';

//------以下是解决路由导航卫士跳转报错问题-------
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};
//------以上是解决路由导航卫士跳转报错问题------
Vue.prototype.$http = axios
// 与 axios.baseURL 一致的静态资源前缀，避免 Global.imgURL 与本地 API 不一致导致图片裂图
Vue.prototype.resolveStaticPic = function (relPath) {
  if (relPath == null || relPath === '') return ''
  const s = String(relPath).trim()
  if (/^https?:\/\//i.test(s)) return s
  const base = (axios.defaults.baseURL || '').replace(/\/?$/, '')
  return base + '/static/pics/' + s.replace(/^\//, '')
}
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
